/** Signature bas de barre — même texte que Chat / le hub. */
export function AureliaCopyright() {
  const year = new Date().getFullYear();
  return (
    <footer className="fx-copyright">
      <p>
        © {year}{" "}
        <a href="https://aureliasuite.fr" target="_blank" rel="noopener noreferrer">
          Aurélia Suite
        </a>
        . Tous droits réservés
        <span className="fx-copyright__sep" aria-hidden>
          •
        </span>
        Conforme RGPD
        <span className="fx-copyright__sep" aria-hidden>
          •
        </span>
        Studio Seth — Pacy-sur-Eure (27)
      </p>
    </footer>
  );
}
